import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=9cc1a31a&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=9cc1a31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc1a31a",
  null
  
)

component.options.__file = "www/vues/client/ChangePassword.vue"
export default component.exports